import { Action } from '@ngrx/store';

import { ReportLeadsOutputApiModel } from '../models/api-models/output';
import { ResponsePaginationApiModel } from '@framework/models';
import { GetReportLeadsInputApiModel } from '../models/api-models/input';


export enum ActionTypes {
    LOAD = '[Company Admin Report Leads] Load',
    LOAD_SUCCESS = '[Company Admin Report Leads] Load Success',
    LOAD_FAIL = '[Company Admin Report Leads] Load Fail',

    LOAD_SPOTLIGHT_LEADS = '[Company Admin Report Leads] Load Spotlight Leads',
    LOAD_SPOTLIGHT_LEADS_SUCCESS = '[Company Admin Report Leads] Load Spotlight Leads Success',
    LOAD_SPOTLIGHT_LEADS_FAIL = '[Company Admin Report Leads] Load Spotlight Leads Fail',
}

export class Load implements Action {
    readonly type = ActionTypes.LOAD;

    constructor(public companyId: number, public queryData: GetReportLeadsInputApiModel) { }
}

export class LoadSuccess implements Action {
    readonly type = ActionTypes.LOAD_SUCCESS;

    constructor(public response: ResponsePaginationApiModel<ReportLeadsOutputApiModel>) { }
}

export class LoadFail implements Action {
    readonly type = ActionTypes.LOAD_FAIL;

    constructor(public error: any) { }
}

export class LoadSpotlightLeads implements Action {
    readonly type = ActionTypes.LOAD_SPOTLIGHT_LEADS;

    constructor(public companyId: number, public queryData: GetReportLeadsInputApiModel) { }
}

export class LoadSpotlightLeadsSuccess implements Action {
    readonly type = ActionTypes.LOAD_SPOTLIGHT_LEADS_SUCCESS;

    constructor(public response: any) { }
}

export class LoadSpotlightLeadsFail implements Action {
    readonly type = ActionTypes.LOAD_SPOTLIGHT_LEADS_FAIL;

    constructor(public error: any) { }
}
export type Actions =
    Load | LoadSuccess | LoadFail | LoadSpotlightLeads | LoadSpotlightLeadsSuccess | LoadSpotlightLeadsFail;
